import React, { Fragment, useContext, useState } from "react";
import DataTable from "react-data-table-component";
import { DropdownItem } from "reactstrap";
import ActionOptions from "../Common/Component/ActionOptions";
import moment from "moment";
import { carColumns } from "../../Data/Driver/CarListing";
import { Spinner } from "../../AbstractElements";
import CommonToolTip from "../Common/Component/CommonToolTip";
import BlockUnblockModal from "./BlockUnblockModal";
import DeleteConfirmationModal from "./DeleteConfirmationModal";
import { Link } from "react-router-dom";
import { getUserRole } from "../../Services/Shared.service";
import { Admin } from "../../Data/SideMenu/RouteMapping";
import CustomizerContext from "../../_helper/Customizer";
import { tmsApi } from "../../api";
import axios from 'axios';
import QrGenerationModal from "../Qr/QrGenerationModal";

const CarTable = ({
    tableData,
    setShowApiLoader,
    fetchTableData,
    paginationPerPage,
    paginationTotalRows,
    onChangePage,
    onChangeRowsPerPage,
    setPageNumber,
    pagination,
    pageNumber,
    loader,
    filterData,
    searchData,
    setEditId,
    toggleCreateCarModal
}) => {
    const [blockUnblockModal, setBlockUnblockModal] = useState(false);
    const toggleBlockUnblockModal = () =>
        setBlockUnblockModal(!blockUnblockModal);

    const [deleteModal, setDeleteModal] = useState(false);
    const toggleDeleteModal = () =>
        setDeleteModal(!deleteModal);

    const [qrConfirmationModal, setQrConfirmationModal] = useState(false);
    const toggleQrConfirmationModal = () =>
        setQrConfirmationModal(!qrConfirmationModal);

    const [carDetails, setCarDetails] = useState({})
    const userRole = getUserRole();
    const { mix_background_layout } = useContext(CustomizerContext)

    const processData = tableData.map((element, index) => {

        const downloadQr = (id) => {

            console.log("ELEMENT VALUE IS >>>>>", element)

            const dataList = [id];
            const config = {
                headers: {
                    token: `${localStorage.getItem('token')}`,
                    "Access-Control-Allow-Origin": "*",
                    'Content-Type': 'application/json'
                },
            };

            axios.post(tmsApi + "v1/entities/cars/qr-code/download", dataList, config)
                .then(response => {
                    console.log(">>>>>>>>>>>>>", response.data.message.replace(/^\[|\]$/g, ''));
                    let url = response.data.message.replace(/^\[|\]$/g, '');

                    axios.get(url, { responseType: 'blob' }) // Set responseType to 'blob' to handle binary data
                        .then(response => {
                            // Create a link element
                            const blobUrl = window.URL.createObjectURL(new Blob([response.data], { type: 'image/png' }));
                            const link = document.createElement('a');
                            link.href = blobUrl;
                            link.setAttribute('download', element?.carNo + '.png'); // Specify the file name ------> Have to work on this, this wont work for bulk download.
                            document.body.appendChild(link);
                            link.click(); // Trigger the download
                            document.body.removeChild(link); // Clean up the link element
                        })
                        .catch(error => {
                            console.error('Error fetching the image:', error);
                        });
                })
                .catch(error => {
                    console.error(error);
                });
        }

        return {
            carNo: <Link
                to={`${process.env.PUBLIC_URL}/car/car-info/${element.id}`}
                onClick={() => setPageNumber(pagination)}
                state={{ previousUrl: window.location.pathname, filterdata: filterData, searchdata: searchData }}
            >
                {element.carNo}
            </Link>,
            registrationNo: element.registrationNo ? element.registrationNo : "-",
            carTypeName: element.carTypeName ? element.carTypeName : "-",
            aggregatorCompanyName: element.aggregatorCompanyName ? element.aggregatorCompanyName : "-",
            serviceCityName: element.serviceCityName ? element.serviceCityName : "-",
            isAvailable: element.isAvailable ? "true" : "false",
            Deleted: element.isDeleted,
            procurementStatus: element?.procurementStatus == "offRoad" ? (
                <span className="status status-red">offRoad</span>
            ) : element?.procurementStatus == "onRoad" ? (
                <span className="status status-green">onRoad</span>
            ) : (
                <span className="status status-grey">Null</span>
            ),
            expiryRemarks: element.expiryRemarks
                ?
                <>
                    <span
                        id={"expiryRemarks" + index}
                        style={{
                            textOverflow: "ellipsis",
                            overflow: "hidden",
                            whiteSpace: "nowrap",
                        }}
                    >
                        {element.expiryRemarks}
                    </span>
                    <CommonToolTip
                        options={{
                            placement: "left",
                            target: "expiryRemarks" + index,
                        }}
                    >
                        {element.expiryRemarks}
                    </CommonToolTip>
                </>
                : "-",
            action: <ActionOptions>
                <Fragment>
                    {element.isAvailable && (element.isDeleted !== true) ?
                        <>
                            <DropdownItem
                                className="border-0"
                                key={"row-edit"}
                                onClick={() => {
                                    setCarDetails(element)
                                    toggleQrConfirmationModal()
                                }}
                            >
                                <i className="fa fa-qrcode"></i> Generate QR
                            </DropdownItem>
                            {
                                element.isQrGenerated ?
                                    <DropdownItem
                                        className="border-0"
                                        key={"row-edit"}
                                        onClick={() => {
                                            downloadQr(element.id);
                                        }}
                                    >
                                        <i className="fa fa-download"></i> Download QR
                                    </DropdownItem> : <></>
                            }
                        </> : <></>
                    }
                    {element.isAvailable && (element.isDeleted !== true) ?
                    <DropdownItem
                        className="border-0"
                        key={"row-edit"}
                        onClick={() => {
                            setEditId(element.id);
                            toggleCreateCarModal();
                        }}
                    >
                        <i className="fa fa-pencil"></i> Edit
                    </DropdownItem> : <></> }
                    <DropdownItem
                        className="border-0"
                        key={"row-edit"}
                        onClick={() => {
                            setCarDetails(element)
                            toggleBlockUnblockModal()
                        }}
                    >
                        <i className="fa fa-ban"></i> {element.isAvailable ? "Block" : "Unblock"}
                    </DropdownItem>
                    {userRole.some((element) => element == Admin) ? <DropdownItem
                        className="border-0"
                        key={"row-edit"}
                        onClick={() => {
                            setCarDetails(element)
                            toggleDeleteModal()
                        }}
                    >
                        <i className="fa fa-trash"></i> {" "}{element.isDeleted ?"Recover":"Delete"}
                    </DropdownItem> : null}
                </Fragment>
            </ActionOptions>
        };
    });

    const conditionalRowStyles = [

        {
          when: row => row["Deleted"] ,
          style: row => ({ backgroundColor: row["Deleted"] ? "#F9B5A6" : ""}),
        },
    ];
    return (
        <Fragment>
            <div className="table-responsive car-table">
                <DataTable
                    columns={carColumns}
                    data={processData}
                    center={true}
                    fixedHeader
                    fixedHeaderScrollHeight={"57vh"}
                    pagination
                    paginationDefaultPage={pageNumber}
                    paginationPerPage={paginationPerPage}
                    paginationTotalRows={paginationTotalRows}
                    onChangePage={onChangePage}
                    onChangeRowsPerPage={onChangeRowsPerPage}
                    // customStyles={customStyles}
                    conditionalRowStyles={conditionalRowStyles}
                    paginationServer
                    progressPending={loader}
                    progressComponent={<div className="loader-box" style={{ height: "57vh" }}>
                        <Spinner attrSpinner={{ className: "loader-3", style: { width: "30px", height: "30px", borderColor: "#39B54A", borderBottomColor: "transparent" } }} />
                    </div>}
                    theme={mix_background_layout == "dark-only" ? "dark" : "default"}
                />
            </div>
            <BlockUnblockModal
                isblocked={carDetails.isAvailable ? false : true}
                carDetails={carDetails}
                fetchData={fetchTableData}
                LargeModaltoggle={toggleBlockUnblockModal}
                Large={blockUnblockModal}
                title={carDetails.isAvailable ? "Block Car" : "Unblock Car"}
                setShowApiLoader={setShowApiLoader}
            />
            <DeleteConfirmationModal
                Large={deleteModal}
                title={carDetails?.isDeleted?"Recover car":"Delete Car"}
                LargeModaltoggle={toggleDeleteModal}
                fetchData={fetchTableData}
                carObj={carDetails}
            />
            <QrGenerationModal
                Large={qrConfirmationModal}
                title={"QR type confirmation"}
                LargeModaltoggle={toggleQrConfirmationModal}
                fetchData={fetchTableData}
                carObj={carDetails}
            />
        </Fragment>
    );
};

export default CarTable;
